import React from "react";
import { COMPONENTS, THEMES } from "../../lib/portalPresence";

const selectCls = "rounded-xl border border-[#E5E7EB] bg-white px-3 py-1.5 text-sm text-[#373A45] focus:border-[#965EA7] focus:outline-none focus:ring-2 focus:ring-[#965EA7]/20";

/**
 * Whether an activity counts towards the 10 asynchronous hours, for how many,
 * and where in the curriculum: the theme, and the component it counts for —
 * the threshold is checked per component (PR 8b). An assignment is evidenced
 * by its hand-in, a material by being opened.
 * `value` is `{counts, hours, theme, component}`; hours stay a string while typed.
 */
export default function AttendanceFields({ value, onChange, kind = "assignment" }) {
  const v = { counts: false, hours: "", theme: "", component: "practical", ...(value || {}) };
  const set = (patch) => onChange({ ...v, ...patch });
  return (
    <div className="grid gap-2 rounded-xl border border-[#E5E7EB] bg-white p-3" data-testid="portal-attendance-fields">
      <label className="flex items-start gap-2 text-sm text-[#373A45]">
        <input type="checkbox" checked={v.counts} onChange={(e) => set({ counts: e.target.checked })}
          className="mt-0.5 h-4 w-4 accent-[#965EA7]" />
        <span>
          <span className="font-semibold">Intră în cele 10 ore asincrone</span>
          <span className="block text-xs text-[#6B7280]">
            {kind === "resource"
              ? "Dovada e deschiderea materialului: cine l-a deschis și când."
              : "Dovada e predarea: cine a predat și când."}
          </span>
        </span>
      </label>
      {v.counts && (
        <div className="grid gap-2 pl-6">
          <label className="flex items-center gap-2 text-sm text-[#373A45]">
            Acoperă
            <input type="number" min="0.25" max="10" step="0.25" inputMode="decimal" value={v.hours}
              onChange={(e) => set({ hours: e.target.value })}
              className="w-20 rounded-xl border border-[#E5E7EB] px-3 py-1.5 text-[15px] tabular-nums text-[#373A45] focus:border-[#965EA7] focus:outline-none focus:ring-2 focus:ring-[#965EA7]/20"
              aria-label="Ore acoperite" />
            ore
          </label>
          <div className="flex flex-wrap items-center gap-2 text-sm text-[#373A45]">
            <select className={selectCls} value={v.theme || ""} onChange={(e) => set({ theme: e.target.value })}
              aria-label="Tema din curriculum" data-testid="portal-attendance-theme">
              <option value="">Tema din curriculum…</option>
              {THEMES.map((name, i) => <option key={name} value={i + 1}>Tema {i + 1} · {name}</option>)}
            </select>
            <select className={selectCls} value={v.component} onChange={(e) => set({ component: e.target.value })}
              aria-label="Componenta" data-testid="portal-attendance-component">
              {COMPONENTS.map((c) => <option key={c.value} value={c.value}>componenta {c.label}</option>)}
            </select>
          </div>
          <p className="text-xs text-[#6B7280]">În curriculum, toate cele 10 ore asincrone sunt la componenta practică.</p>
        </div>
      )}
    </div>
  );
}
